/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

import { useCallback } from 'react';

import type React from 'react';

import { useMenu } from '../../ContextMenu';

import type { GridStoreImpl as GridStore } from '../stores';

export const useContextMenu = <RowDataT, TotalRowDataT, FilterT>(
    store: GridStore<RowDataT, TotalRowDataT, FilterT>,
    gridRef: React.MutableRefObject<HTMLDivElement>
) => {
    const [contextMenu, contextMenuStore] = useMenu<RowDataT, TotalRowDataT, FilterT>({
        gridApi: store,
    });

    const onContextMenu = useCallback((event: MouseEvent) => {
        event.preventDefault();

        if (!event.composedPath().includes(gridRef.current)) {
            return;
        }

        contextMenuStore.show({
            x: event.clientX,
            y: event.clientY,
        });
    }, [gridRef]);

    return {
        contextMenu,
        onContextMenu,
    };
};